import { configureStore } from "@reduxjs/toolkit";
import { api } from "store/slices/api";
import spinner from "store/slices/spinner";
import loggedInUser from "store/slices/user";
import siteRepo from "store/slices/siteRepo";
import priceQuote from "store/slices/priceQuote";
import laborTable from "store/slices/laborTable";
import programBuilder from "store/slices/programBuilder";

const store = configureStore({
  reducer: {
    [api.reducerPath]: api.reducer,
    loggedInUser,
    spinner,
    siteRepo,
    priceQuote,
    laborTable,
    programBuilder,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(api.middleware),
});

export default store;
